export class WeatherModel {
  constructor(
    public cityName: string,
    public temp: string,
    public icon: string,
    public weatherType: string,
    public tempMin: string,
    public tempMax: string
  ) {}
}
